export const normalizeString = (str: string): string =>
  str
    .toLocaleLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const haveTerm = (str: string | null, term: string): boolean =>
  normalizeString(str || '').includes(normalizeString(term));
